import log from 'loglevel';
import remote from 'loglevel-plugin-remote';
import ApiListDev from '../../resources/json/listOfApi-dev.json';
import ApiListLocal from '../../resources/json/listOfApi-local.json';
import ApiListTest from '../../resources/json/listOfApi-test.json';
import ApiListProd from '../../resources/json/listOfApi-prod.json';


let apiPath;
if (process.env.REACT_APP_ENV === 'LOCAL') {
    apiPath = ApiListLocal.logs;
} else if (process.env.REACT_APP_ENV === 'DEV') {
    apiPath = ApiListDev.logs;
} else if (process.env.REACT_APP_ENV === 'TEST') {
    apiPath = ApiListTest.logs;
} else if(process.env.REACT_APP_ENV === 'PROD') {
    apiPath = ApiListProd.logs;
}



/* const customJSON = log => ({
    message: log.message,
    level: log.level.label,
    stacktrace: log.stacktrace
}); */


remote.apply(log, {
    /* format: customJSON, */
    url: apiPath,
    headers: {
        'guid': "OTEyMjQwZTUtNTZhYS00NjliLTllZjYtYjU2ZTk5ZWVmNDdh"
    },
    stacktrace: {
        depth: 10
    },
    timestamp: () => new Date().toLocaleString(),
    format: remote.plain,
});

export default log;